import { FormGroup, Input, Label } from 'reactstrap';

interface Props {
    email?: string;
    errors?: boolean;
    propertyName: string;
    onFieldChange:(prop: string, value: string) => void;
}

const EmailAddress = (props:Props) => {
    return (
        <FormGroup floating className="mt-3">
            <Input
                id="Email"
                name={props.propertyName}
                placeholder="example@example.com"
                type="email"
                value={props.email}
                onChange={(e) => props.onFieldChange(e.target.name, e.target.value)}
                className={props.errors ? "input-validation-error" : ""} />
            <Label for="Email">
                Email Address
            </Label>
            {props.errors && <span className="text-danger">Please enter an Email</span>}
        </FormGroup>
    );
}

export default EmailAddress;